module.exports = require('./helpers/bundle-url').getBundleURL('dzWzf') + "logo.c51670a8.svg";